import { type LanguageCode } from '@/stores/locale';

export type FormatCurrencyOptions = {
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currencyDisplay?: 'symbol' | 'code';
};

export const formatCurrency = (
  number: number,
  lang: LanguageCode,
  currency?: string | null,
  options: FormatCurrencyOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currencyDisplay: 'code',
  },
): string => {
  if (Number.isNaN(number)) {
    return '';
  }

  // Resolve currency from positional parameter or options
  const resolvedCurrency = currency ?? options.currency;

  if (!resolvedCurrency || !lang) {
    return String(number ?? '');
  }

  const formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: resolvedCurrency,
    currencyDisplay: options.currencyDisplay ?? 'code',
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  });

  return formatter.format(number ?? 0);
};
